import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CommonComponentsModule } from "src/app/common-components";
import { InfoportalApiDialogsModule } from "../dialogs/infoportal-dialogs.module";
import { InfoportalApiContractDocumentsTreeComponent } from "./contract-documents-tree/contract-documents-tree.component";
import { InfoportalApiReceiptDocumentsTreeComponent } from "./receipt-documents-tree/receipt-documents-tree.component";

@NgModule({
  imports: [CommonModule, CommonComponentsModule, InfoportalApiDialogsModule],
  declarations: [
    InfoportalApiContractDocumentsTreeComponent,
    InfoportalApiReceiptDocumentsTreeComponent,
  ],
  exports: [
    InfoportalApiContractDocumentsTreeComponent,
    InfoportalApiReceiptDocumentsTreeComponent,
  ],
})
export class InfoportalApiComponentsModule {}
